// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-3WV5U","btnDetail":"index-btnDetail-14jC0"};